import "./scss/style.scss";
import "./js/lib/utils";
// import Cookies from "./js/template-parts/popups/cookies";

const libraries = {};
window.modules = [];
window.captchaLoaded = false;
window.googleapi = false;

// Cookies banner
// window.cookies = new Cookies();

// Modules loader
import(/* webpackChunkName: "modules-loader" */ "./js/modules-loader").then(
	({ default: ModulesLoader }) => {
		window.modulesLoader = new ModulesLoader();
	}
);

// AlpineJS
import(/* webpackChunkName: "library-alpinejs" */ "alpinejs").then(
	({ default: Alpine }) => {
		window.Alpine = Alpine;
		Alpine.start();
	}
);

// Load libraries
libraries.lazyLoading = {
	fileName: "lazy-loading",
	cssClassName: ".barba-container",
};
libraries.barba = {
	fileName: "barba",
	cssClassName: ".barba-container",
};
window.loadJsLibraries(libraries);
